const template = require('./paymentConfigBooking.html');

const NS = 'PaymentConfigBooking';

export default function PaymentConfigBooking() {
  "ngInject";

  return {
    bindToController: true,
    controller,
    template,
    controllerAs: 'vm',
    restrict: 'E',
    scope: {
      paymentForm: '=?',
      displayErrors: '<',
      details: '=',
      types: '=',
      disableType: '=',
      isChangeByUser: '=',
      isPaymentTypeChanged: '=',
      isPriceChanged: '=',
      isEditBooking: '=?',
      disabled: "="
    }
  };

  function controller($scope, appConstants, unregister) {
    "ngInject";
    const vm = this;
    vm.paymentTypes = appConstants.Payment.PaymentTypes;
    vm.paymentChangedByUser = paymentChangedByUser;

    var listeners = [];
    listeners.push($scope.$watch('vm.types', typesChange));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    function paymentChangedByUser(isChangeByUser, value) {
      if (isChangeByUser) {
        vm.isChangeByUser = value;
        value === 'type' ? vm.isPaymentTypeChanged = false : vm.isPriceChanged = false;
        if (vm.details.paymentType === appConstants.Payment.PaymentTypes.NoPayment) {
          vm.details.price = 0;
        }
      }
    }

    function typesChange() {
      if (vm.types.find(type => type.code === vm.details.paymentType) == null) {
        vm.details.paymentType = vm.types.length ?
          vm.types[0].code :
          vm.paymentTypes.NoPayment;
      }
    }
  }
}
